import { render, staticRenderFns } from "./ShopButton.vue?vue&type=template&id=27835b02&scoped=true"
import script from "./ShopButton.vue?vue&type=script&lang=js"
export * from "./ShopButton.vue?vue&type=script&lang=js"
import style0 from "./ShopButton.vue?vue&type=style&index=0&id=27835b02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27835b02",
  null
  
)

export default component.exports